// extracted by mini-css-extract-plugin
export var cardGrid = "card-grid-module--card-grid--c49a4";
export var cardGridCompact = "card-grid-module--card-grid--compact--abdce";
export var cardGridLarge = "card-grid-module--card-grid--large--a350a";
export var cardGridMedium = "card-grid-module--card-grid--medium--41759";
export var cardGridWide = "card-grid-module--card-grid--wide--88ab3";
export var link = "card-grid-module--link--d5999";
export var meta = "card-grid-module--meta--752ec";
export var title = "card-grid-module--title--a8216";